import React, { useEffect } from 'react';
import './App.css';
import PageRoutes from './routes/PageRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { registerServiceWorker } from "./serviceWorkerRegistration";

function App() {
  useEffect(() => {
    // Register SW only — do NOT request notification permission before login
    if ("requestIdleCallback" in window) {
      requestIdleCallback(registerServiceWorker);
    } else {
      setTimeout(registerServiceWorker, 3000);
    }
  }, []);

  return (
    <PageRoutes />
  );
}

export default App;
